// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsIndicatorsPage_wrapper__xeydp"};